export default "__VITE_ASSET__sR8SJ8bD__"